<template>
<div class="project-control-documents" :style="[showBorder == false ? {'border-bottom' : 'none'} : {'border-bottom' : '2px dashed #4D92DF'}]">
  <h4 v-if="showEdit">Your link to End-client</h4> 
  <div v-else class="header-top-section">Your link to End-client</div>
   <div id="project_clientDetails">
        <div class="ul clearfix">
            <div class="li"  v-for="(t, index) in link" :key="index" v-bind:class="{'borderd' : t.Type == 'EndClient' || t.Type == 'Self'}">
                <i :class="arrowClass(index)" v-if="t.Type.toLowerCase() != 'self'"><span><div class="circle" style="font-size: 5px;margin:-31px;display:block;"></div></span></i>
                <p class="website_txt m0 text-uppercase">
                    <span>{{ getNameByType(t.Type)}}</span>
                    <span v-if="index !== 0 && t.Type.toLowerCase() != 'self' && getNameByType(t.Type) !='Contractor'">(Tier{{getTierNumber(index)}})</span> 
                </p>
              <p class="website_org m0 text-capitalize" :title="t.OrganizationName" v-if="t.OrganizationName !='' && t.OrganizationName!= null">{{t.OrganizationName}}</p>
              <p class="website_org m0" :title="t.OrganizationName" v-else>N/A</p>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    props: {
            link:{},
            onTaxTermData:{},
            showEdit:{
                    type: Boolean,
                    default: true
            },
            showBorder:{
                type: Boolean,
                default: false
            }
        },
    methods: {
        getTierNumber(index) {
            let selfIndex = this._getSelfIndex();
           if(selfIndex > index) { // Client
                return index;
            } else { // Vendor
                return index - selfIndex;
            }
        },
        getNameByType(type) {
            type = type.toLowerCase();
            return type == "endclient"
                ? "End Client"
                : type == "client"
                ? "Client"
                : type == "self" ? "Your Organization" : this.onTaxTermData == "1099" ? "Contractor" : "Vendor";
        },
         arrowClass(index) {
             if(this._getSelfIndex() > index) {
                return 'left'
            } else {
                return 'right'
            }
         },
        _getSelfIndex() {
            if(this.link) {
                return this.link.findIndex((c) => c.Type.toLowerCase() == 'self')
            } else {
                return 0
            }
        },
        
    },

}
</script>
<style lang="scss" scoped>
.project-control-documents .col-md-3 {
    margin-bottom: 10px;
    padding-left:0;
}

.project-control-documents.editing .headline-message { 
    overflow: visible;
}

.project-control-documents.editing input[readonly] {
    background-color: #eeeeee !important;
}
#project_clientDetails{
    overflow: auto;
  .ul{
    margin:4px;
    display: inline-flex;
    .li{
         width: 145px;
    height: 64px;
    position: relative;
    list-style-type: none;
    background: white;
    padding: 12px 10px 10px 12px;
    border: 2px solid white;
   -webkit-box-shadow: 0 0 9.5px #dcd7d7;
    box-shadow: 0 0 9.5px #dcd7d7;
    border-radius: 0%;
    float: left;
    margin-left: 62px;
    margin-bottom: 25px;
    .website_txt{
                font-size: 11px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                padding-bottom:1.5px;
                font-weight:600;
      }
      .website_org{
            color: #143361;
            font-size: 13px;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
      }
      &:after{
        content: '';
        background: #656262;
        position: absolute;
        top: 28.6px;
        width: 46px;
        height: 2px;
        margin-left:139px;
      }
      .circle {
          width: 1em;
          height: 1em;
          box-sizing: initial;
          background: #fff;
          border: 0.3em solid #656262;
          color: #666;
          border-radius: 50%;    
          line-height: 2rem;
          box-sizing: content-box;   
        }
       &:last-child:after{
          width: 0px !important;
        }
        &:last-child{
         .left {
           display:none;
         }
        }
        &:first-child{         
         margin-left:0;       
        }
        i {
            border: solid #656262 ;
            border-width: 0 1.5px 1.5px 0;
            display: inline-block;
            padding: 3px; 
        }
        .right {
            position: absolute;
            left: -20px;
            top: 26px;
            border-color:none;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);  
        }
        .left {
            position: absolute;
            right:-14px;
            margin-right: -4px;
            top: 26px;
            z-index: 1;
            border-color:none;
            transform: rotate(135deg);
            -webkit-transform: rotate(135deg);
           } 
         } 
     }
  }
#project_clientDetails .ul .Vendor-org i.left{ 
    display:none;
}
.borderd{
         border:2px solid gray !important;
         background: white !important;
         -webkit-box-shadow: 0 0 0 !important;
          box-shadow: 0 0 0 !important;
      }
.edit-link-client{
    float: right;
    margin-right: 17px;
    font-weight: 600;
    font-size: 13px;
    font-style: italic;
}
.header-top-section {
      background: #eeeeef;
      padding: 10px 29px;
      font-size: 14px;
      font-weight: 600;
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/ESSProjects/EmpLinkFlowDiagram.vue